import React from "react";
import {
  Section,
  MainTitleContainer,
  Title,
  SectionBody,
} from "./Namedsection.styles";
import SectionItem from "../SectionItem/SectionItem";

const NamedSection = ({ sectionName, data, handleReedMore }) => {
  return (
    <Section>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MainTitleContainer>
          <Title>{sectionName}</Title>
        </MainTitleContainer>
      </div>
      <SectionBody>
        {data.map(
          ({
            id,
            image,
            slug,
            category,
            title,
            author,
            excerpt,
            description,
          }) => (
            <SectionItem
              key={id}
              title={title}
              slug={slug}
              category={category}
              author={author}
              image={image}
              excerpt={excerpt}
              description={description}
              handleReedMore={handleReedMore}
            />
          )
        )}
      </SectionBody>
    </Section>
  );
};

export default NamedSection;
